module.exports = __webpack_public_path__ + "static/media/profile.6590cd7f.gif";